module.exports = __webpack_public_path__ + "static/juice.94863fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/hero/juice.jpg
// module id = 1045
// module chunks = 213534597649335